//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { type Ref } from '@hcengineering/core'
import { type Asset, type IntlString, type Plugin, plugin } from '@hcengineering/platform'
import { type AnyComponent } from '@hcengineering/ui'
import { type Viewlet, type ViewletDescriptor } from '@hcengineering/view'

/**
 * @public
 */
export const trackerCalendarViewId = 'tracker-calendar-view' as Plugin

/**
 * @public
 */
const trackerCalendarView = plugin(trackerCalendarViewId, {
  component: {
    IssueCalendarView: '' as AnyComponent
  },
  icon: {
    CalendarView: '' as Asset
  },
  string: {
    CalendarView: '' as IntlString,
    NoDate: '' as IntlString,
    Today: '' as IntlString,
    Unscheduled: '' as IntlString,
    Sunday: '' as IntlString,
    Monday: '' as IntlString,
    Tuesday: '' as IntlString,
    Wednesday: '' as IntlString,
    Thursday: '' as IntlString,
    Friday: '' as IntlString,
    Saturday: '' as IntlString,
    CreateTask: '' as IntlString,
    MoreIssues: '' as IntlString,
    ShowLess: '' as IntlString,
    DropTaskHere: '' as IntlString,
    Empty: '' as IntlString
  },
  viewlet: {
    Calendar: '' as Ref<ViewletDescriptor>,
    IssueCalendar: '' as Ref<Viewlet>
  }
})

export default trackerCalendarView
